import request from '@/utils/request'
// 获取课程数据
export function getCourses(data) {
  return request({
    url: 'stats/course/search',
    method: 'POST',
    data,
  })
}
// 获取课程排行数据
export function getCourseRank(data) {
  return request({
    url: 'stats/course/rank',
    method: 'POST',
    data,
  })
}
// 获取课程基本情况
export function getCourseBase(data) {
  return request({
    url: 'stats/course/base',
    method: 'POST',
    data,
  })
}
// 获取课程详细信息
export function getCourseDetail(data) {
  return request({
    url: 'stats/course/detail',
    method: 'POST',
    data,
  })
}
// 更新课程统计
export function updateCourseStats(data) {
  return request({
    url: 'stats/course/update',
    method: 'POST',
    data: {
      ...data,
      capability: 1 // 1为能力图谱
    },
  })
}
// 课程统计进度查询
export function getCourseUpdateStats(data) {
  return request({
    url: 'stats/course/updateStatus',
    method: 'POST',
    data,
  })
}
// 课程筛选设置
export function setCourseFilter(data) {
  return request({
    url: 'stats/course/setting',
    method: 'POST',
    data,
  })
}
// 获取教学统计数据
export function getActStat(data) {
  let { responseType, ...restData } = data
  return request({
    url: 'stats/course/actStat',
    method: 'POST',
    data: restData,
    responseType: responseType || '',
  })
}
// 获取教学活动详情
export function getActDetail(data) {
  return request({
    url: 'stats/course/actDetail',
    method: 'POST',
    data,
  })
}
// 获取教学活动学生详情
export function getActStudent(data) {
  return request({
    url: 'stats/course/actStudent',
    method: 'POST',
    data,
  })
}
// 获取课程访问/任务完成排行
export function getCourseSituationRank(data) {
  return request({
    url: 'stats/course/situationRank',
    method: 'POST',
    data,
  })
}
// 获取学情分析图表
export function getSituationChart(data) {
  return request({
    url: 'stats/course/situationChart',
    method: 'POST',
    data,
  })
}
// 学员档案
// 获取学员档案列表
export function getStudentDoc(data) {
  let { responseType, ...restData } = data
  return request({
    url: 'stats/course/student',
    method: 'POST',
    data: restData,
    responseType: responseType || '',
  })
}
// 获取学员档案详情
export function getStudentDocDetail(data) {
  return request({
    url: 'stats/course/studentDetail',
    method: 'POST',
    data,
  })
}
// 异常预警
// 获取课程建议
export function getCourseSuggest(data) {
  return request({
    url: 'stats/course/courseSuggest',
    method: 'POST',
    data,
  })
}
// 获取未访问课程列表
export function getAccessWarn(data) {
  return request({
    url: 'stats/course/accessWarn',
    method: 'POST',
    data,
  })
}
// 获取作业完成异常列表
export function getAssignWarn(data) {
  return request({
    url: 'stats/course/assignWarn',
    method: 'POST',
    data,
  })
}
// 获取测验完成异常列表
export function getQuizWarn(data) {
  return request({
    url: 'stats/course/quizWarn',
    method: 'POST',
    data,
  })
}
// 获取讨论参与异常列表
export function getForumWarn(data) {
  return request({
    url: 'stats/course/forumWarn',
    method: 'POST',
    data,
  })
}
// 获取不及格预警列表
export function getGradeWarn(data) {
  return request({
    url: 'stats/course/gradeWarn',
    method: 'POST',
    data,
  })
}
// 获取课程小组
export function getCourseGroup(data) {
  return request({
    url: 'stats/course/group',
    method: 'POST',
    data,
  })
}
// 获取课程选课方式列表
export function getCourseJoinType(data) {
  return request({
    url: 'stats/course/joinType',
    method: 'POST',
    data,
  })
}
